import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PersonIcon from '@material-ui/icons/Person';
import GroupIcon from '@material-ui/icons/Group';

export const AanwezigenProfessioneel = AssignmentIndIcon;
export const AanwezigenNietProfessioneel = PersonIcon;
export const AanwezigenDefault = GroupIcon;